import { connect } from 'react-redux';
import ProjectsPage from '../components/ProjectsPage';

/*
  Map state and dispatch to component props
*/

const mapStateToProps = ({ projects, forms }) => ({
  projects,
  forms
});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProjectsPage);



// WEBPACK FOOTER //
// ./src/containers/Projects.js